import React, {useState, useEffect} from 'react';
import * as api from "../../../services/api";

import {useFeedbackTools} from "../../../components/FeedbackTools";
import Page from "../../../layouts/Main/Page";

import {
    filterAttributes,
    selectMinNightsRule,
    selectMinPeopleRule,
    selectMaxPeopleRule,
    selectMaxPetsRule,
    selectBookingRule
} from "../../../services/filterRules";
import {RuleSection} from "./RuleSection";
import {RuleCard} from "./RuleCard";

import {Container} from '@mui/material';

import {red, purple, blue, green, lime, teal} from '@mui/material/colors';

import {
    DateRange as DateRangeIcon,
    Pets as PetsIcon,
    AccessTime as AccessTimeIcon,
    Person as PersonIcon,
    People as PeopleIcon,
    EventNote as EventNoteIcon
} from '@mui/icons-material';

const AllRules = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [groupedRules, setGroupedRules] = useState({});

    const {showErrorNotification} = useFeedbackTools();

    useEffect(() => {
        const loadRules = async () => {
            try {
                const ruleList = await api.FilterRules.getAllRule();
                const rules = ruleList.reduce((acc, x) => {
                    if (acc[x.ruleType]) {
                        acc[x.ruleType].push(x);
                    } else {
                        acc[x.ruleType] = [x];
                    }
                    return acc;
                }, {});
                setGroupedRules(rules);
            } catch (e) {
                showErrorNotification(e);
            }
            setIsLoading(false);
        };

        loadRules();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Page title="Filtri richieste" loading={isLoading}>
            <Container maxWidth="md" disableGutters={true}>

                <RuleSection title="Calendario prenotazioni"
                             avatarColor={teal[600]}
                             AvatarIcon={EventNoteIcon}>
                    <RuleCard initialRule={selectBookingRule(groupedRules['10'])}
                              initialTemporalRules={[]}
                              attributes={filterAttributes.bookingAttributes}
                              avatarColor={teal[600]}
                              AvatarIcon={EventNoteIcon}/>
                </RuleSection>

                <RuleSection title="Periodo"
                             avatarColor={red[600]}
                             AvatarIcon={DateRangeIcon}>
                    <RuleCard initialRule={null}
                              initialTemporalRules={groupedRules['1']}
                              attributes={filterAttributes.periodAttributes}
                              avatarColor={red[600]}
                              AvatarIcon={DateRangeIcon}/>
                </RuleSection>

                <RuleSection title="Minimo notti"
                             avatarColor={blue[600]}
                             AvatarIcon={AccessTimeIcon}>
                    <RuleCard initialRule={selectMinNightsRule(groupedRules['2'])}
                              initialTemporalRules={groupedRules['52']}
                              attributes={filterAttributes.minNightsAttributes}
                              avatarColor={blue[600]}
                              AvatarIcon={AccessTimeIcon}/>
                </RuleSection>

                <RuleSection title="Minimo persone"
                             avatarColor={green[600]}
                             AvatarIcon={PersonIcon}>
                    <RuleCard initialRule={selectMinPeopleRule(groupedRules['3'])}
                              initialTemporalRules={groupedRules['53']}
                              attributes={filterAttributes.minPeopleAttributes}
                              avatarColor={green[600]}
                              AvatarIcon={PersonIcon}/>
                </RuleSection>

                <RuleSection title="Massimo persone"
                             avatarColor={lime[600]}
                             AvatarIcon={PeopleIcon}>
                    <RuleCard initialRule={selectMaxPeopleRule(groupedRules['4'])}
                              initialTemporalRules={groupedRules['54']}
                              attributes={filterAttributes.maxPeopleAttributes}
                              avatarColor={lime[600]}
                              AvatarIcon={PeopleIcon}/>
                </RuleSection>

                <RuleSection title="Animali domestici"
                             avatarColor={purple[600]}
                             AvatarIcon={PetsIcon}>
                    <RuleCard initialRule={selectMaxPetsRule(groupedRules['5'])}
                              initialTemporalRules={groupedRules['55']}
                              attributes={filterAttributes.maxPetsAttributes}
                              avatarColor={purple[600]}
                              AvatarIcon={PetsIcon}/>
                </RuleSection>
            </Container>
        </Page>
    );
};

export default AllRules;